import {
  Component,
  Injector,
  OnInit,
  SecurityContext,
  WritableSignal,
  inject,
  input,
  model,
  runInInjectionContext,
  signal,
} from '@angular/core';
import { InvoiceHandlingMode, SectionId, SectionType } from '../theme.types';
import { InvoicePositionModel } from '../../../core/models/finance/financial-record.model';
import { BaseInvoiceThemeModel } from '../../../core/models/invoice/base-invoice-theme.model';
import { ContentArea } from '../../../core/models/invoice/invoice-document-detail.model';
import { InvoiceStateService } from '../../../pages/finances/invoices/invoice-creation-editing/state-and-data-handling/invoice-state.service';
import { KeyValueRecord } from '../../../shared/functions/record-functions';

@Component({
  selector: 'app-base-template',
  template: '',
  host: { class: 'template-host' },
})
export abstract class BaseTheme implements OnInit {
  // Inputs / outputs
  protected themeProps: WritableSignal<BaseInvoiceThemeModel> =
    model.required<BaseInvoiceThemeModel>();
  protected contentAreas: WritableSignal<Map<SectionId, ContentArea>> =
    model.required<Map<SectionId, ContentArea>>();
  protected invoicePositions: WritableSignal<InvoicePositionModel[]> =
    model.required<InvoicePositionModel[]>();
  protected mode = input.required<InvoiceHandlingMode>();
  protected meta = signal<KeyValueRecord[]>([]);

  protected readonly SectionType = SectionType;
  protected readonly SecurityContext = SecurityContext;

  // DI
  protected readonly invoiceStateService = inject(InvoiceStateService);
  private readonly injector = inject(Injector);

  ngOnInit(): void {
    // If we print a PDF, don't load the data since it is already loaded in the resolver.
    if (this.mode() === 'print') {
      return;
    }

    // Set all necessary data saved in the store.
    runInInjectionContext(this.injector, () => {
      this.themeProps = this.invoiceStateService.themeProps;
      this.contentAreas = this.invoiceStateService.contentAreas;
      this.invoicePositions = this.invoiceStateService.invoicePositions;
      this.meta = this.invoiceStateService.meta;
    });
  }
}
